import React, {useEffect, useState} from 'react';

const Scrollbar = () => {

    const [show,setShow]=useState(true)

    useEffect(() => {
        setShow(window.self === window.top)
    }, []);


    if(!show){
        return null
    }

    return(
        <div className="col-lg-12">
            <div className="header-menu">
                <ul className="smothscroll">
                    <li><a href='#scrool'><i className="fa fa-arrow-up"></i></a></li>
                </ul>
            </div>
        </div>

    )
}

export default Scrollbar;
